
import { TranslationsByLanguage } from './types';

export type ExploreTranslationKey =
  | 'explore.clips.title'
  | 'explore.clips.description'
  | 'explore.channels.title'
  | 'explore.channels.description'
  | 'explore.playlists.title'
  | 'explore.playlists.description'
  | 'explore.derivatives.title'
  | 'explore.derivatives.description';

export const exploreTranslations: TranslationsByLanguage = {
  en: {
    'explore.clips.title': 'Clips',
    'explore.clips.description': 'Browse our library of available clips.',
    'explore.channels.title': 'Channels',
    'explore.channels.description': 'Explore content from our rights holders.',
    'explore.playlists.title': 'Playlists',
    'explore.playlists.description': 'Discover collections of clips.',
    'explore.derivatives.title': 'Creations',
    'explore.derivatives.description': 'See how creators have transformed clips into new creative expressions.'
  },
  fr: {
    'explore.clips.title': 'Clips',
    'explore.clips.description': 'Parcourez notre bibliothèque de clips disponibles.',
    'explore.channels.title': 'Chaînes',
    'explore.channels.description': 'Explorez le contenu de nos ayants droit.',
    'explore.playlists.title': 'Playlists',
    'explore.playlists.description': 'Découvrez des collections de clips.',
    'explore.derivatives.title': 'Créations',
    'explore.derivatives.description': 'Découvrez comment les créateurs ont transformé les clips en nouvelles expressions créatives.'
  }
};
